import { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../../baseComponents/EditCardTabs'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { setVariablesToCurrentPage } from '../../../../../../../utils/reducers/reduxDispatch'
import { getProductName } from '../../Products/SingleProduct/function'
import MainPackaging from './Tabs/MainPackaging'
import OtherInformation from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/OtherInformation'
import ProductComposed from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/ProductComposed'
import SpecificPricesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SpecificPricesProduct'
import StockProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/StockProduct'
import SuppliersProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SuppliersProduct'
import { ProductExtendedTyShort } from '../../../../../../../specificComponents/Product/types'


type SinglePackagingProps = SinglePackagingLogicProps & ComponentWithPermissions & {}

const SinglePackaging: React.FC<SinglePackagingProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSinglePackagingLogic({ params })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainPackaging, text: t('general', 'General'), permission: 'product.packaging.main' },
        'stock': { component: StockProduct, text: t('stock', 'Inventario'), permission: 'product.packaging.stock' },
        'prices': { component: SpecificPricesProduct, text: t('prices', 'Precios'), permission: 'product.packaging.specificPrice' },
        'product-composed': { component: ProductComposed, text: t('productComposed', 'Producto Compuesto'), permission: 'product.packaging.productComposed' },
        'suppliers': { component: SuppliersProduct, text: t('suppliers', 'Proveedores'), permission: 'product.packaging.supplier' },
        'other-information': { component: OtherInformation, text: t('otherInformation', 'Otra información'), permission: 'product.packaging.otherInformation' },
    }
    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

interface SinglePackagingLogicProps {
    params: { id?: string, tab?: string }
}

const useSinglePackagingLogic = ({ params }: SinglePackagingLogicProps) => {
    const [basicData, setBasicData] = useState<ProductExtendedTyShort | null>(null)
    const id = params.id

    const getData = useCallback(async () => {
        const myData: ProductExtendedTyShort = await twinFetchPostJSON('/api/app/product/getProductInstanceComplete', {
            id,
        })
        if (myData) {
            myData['name'] = getProductName(myData.ProductLangs)
            setBasicData(myData)
            setVariablesToCurrentPage([myData['name']])
        }
    }, [setBasicData, id])

    useEffect(() => {
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SinglePackaging